import axios from "../axioxInstance";

const getUser = async () => {
    let userInfoStringify = localStorage.getItem("userData")
    let userData = userInfoStringify ? JSON.parse(userInfoStringify) : null

    let resolved = {
        data: null,
        error: userData ? null : "401 Unauthorized"
    }
    if (userData) {
        try {
            const res = await axios({
                url: `auth/`,
                method: "GET",
                headers: {
                    // Authorization: logedIn == "true" ? `Bearer ${token}` : null
                    "userid": userData ? userData._id : null
                },
                withCredentials: true
            })
            resolved.data = res.data
        } catch (err) {
            if (err.response && err.response.data) {
                resolved.error = err.response.data
            } else {
                resolved.error = {
                    message: "SomeThing went Wrong"
                }
            }

        }
    }

    return resolved;
}


const addUser = async (phone = null, email = null, fn = null, ln = null, image = null, loginSite) => {
    let resolved = {
        data: null,
        error: null
    }

    let localCoins = localStorage.getItem('localCoins') != null ? localStorage.getItem('localCoins') : 0
    localStorage.removeItem('localCoins');

    try {
        const res = await axios({
            url: `auth/add_user`,
            method: "POST",
            headers: {
                // "userid": userData ? userData._id : null
            },
            data: {
                phone,
                email,
                fn, ln, image, localCoins,loginSite
            },
            withCredentials: true

        })
        resolved.data = res.data
    } catch (err) {
        if (err.response && err.response.data) {
            resolved.error = err.response.data
        } else {
            resolved.error = {
                message: "SomeThing went Wrong"
            }
        }

    }

    return resolved;
}

const updateUser = async (phone = null, email = null, coins, quizPlayed=[],siteLogin=[]) => {
    let resolved = {
        data: null,
        error: null
    }

    try {
        const res = await axios({
            url: `auth/update_user`,
            method: "PUT",
            headers: {
                // "userid": userData ? userData._id : null
            },
            data: {
                phone,
                email,
                coins,
                quizPlayed,
                siteLogin
            },
            withCredentials: true

        })
        resolved.data = await res.data
        
    } catch (err) {
        if (err.response && err.response.data) {
            resolved.error = err.response.data
        } else {
            resolved.error = {
                message: "SomeThing went Wrong"
            }
        }

    }

    return resolved;
}


const logoutUser = async () => {
   await axios({
       url:`auth/logout`,
       method:"GET"
   })
}



export { getUser, addUser, updateUser, logoutUser }